import styled from 'styled-components';
import { cvBreakpoint768 } from '@carvana/theme';
import { WizardHeading, WizardText } from '../../document-wizard-modal.styles';

export const DocumentErrorWrapper = styled.div`
  padding: 140px 24px 0;
  max-width: 400px;

  @media (min-width: ${cvBreakpoint768}px) {
    max-width: initial;
  }
`;

export const DocumentErrorMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DocumentErrorHeading = styled(WizardHeading)`
  font-size: 20px;
  text-align: center;
`;

export const DocumentErrorTextBody = styled(WizardText)`
  margin-top: 20px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 30px;
`;
